var _effectorFileName = "/builds/gmini/front-sm-api-sdk/src/BimEntity/BimModelElementSource.ts";
import * as t from 'io-ts';
import { Id } from '../Id';
import { Version } from '../Version';
export var BimModelElementSource = t.union([t.array(t.type({
  modelId: Id,
  modelVersion: Version,
  sourceId: Id,
  sourceType: t.union([t.literal('BimModel'), t.literal('BimCategory'), t.literal('BimFamily'), t.literal('BimStandardSize'), t.literal('BimElement')])
}, 'BimModelElementSource')), t["null"]]);